<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <loading-spinner v-if="isLoading"></loading-spinner>
        <paginated-table v-else :data="members" :columns="columns" :title="$t('title.member_approval_request')"
          @updatePagination="updatePagination"></paginated-table>
      </v-col>
    </v-row>

    <info-modal :data="currentMember" :isVisible="showDetailInfo" @close="showDetailInfo = false"></info-modal>
    <div>
    </div>
  </v-container>
</template>

<script>
import PaginatedTable from "@/components/Tables/PaginatedTable.vue";
import InfoModal from "@/components/cards/InfoModal.vue";
import LoadingSpinner from '@/components/common/Spinners/LoadingSpinner.vue';

import { acceptMember, rejectMemberPopup } from "@/views/MemberView/popups";
import { getApprovalRequestColumns } from "@/views/MemberView/columns";

import { memberApi } from "@/api/api"

export default {
  components: {
    PaginatedTable,
    LoadingSpinner,
    InfoModal,
  },

  data() {
    return {
      isLoading: false,
      members: {
        page_info: {
          page: 1,
          size: 5,
          total_elements: 5,
          total_pages: 1,
        },
        elements: [],
      },
      showDetailInfo: false,
      currentMember: {},
      columns: getApprovalRequestColumns({
        showDetail: this.showDetail,
        accept: this.handleAccept,
        delete: this.handleRejectMember,
      }),
    };
  },

  created() {
    this.getMembers();
  },

  methods: {
    showDetail(item) {
      this.currentMember = {
        title: {
          label: this.$t("label.member_name"),
          value: item.name,
        },
        phone: {
          label: this.$t("label.member_phone"),
          value: item.phone
        },
        email: {
          label: this.$t("label.member_email"),
          value: item.email
        },
        created_at: {
          label: this.$t("label.member_created_at"),
          value: item.created_at
        },
        organization: {
          label: this.$t("label.member_organization"),
          value: item.organization
        },
        department: {
          label: this.$t("label.member_department"),
          value: item.department
        },
        position: {
          label: this.$t("label.member_position"),
          value: item.position
        },
        sns_account: {
          label: this.$t("label.member_sns_account"),
          value: item.sns_account_provider
        },
      };
      this.showDetailInfo = !this.showDetailInfo;
    },

    async handleAccept(member) {
      const selectedValue = await acceptMember(member);

      if (selectedValue) {
        this.updateMemberType(member, selectedValue);
      }
    },

    async handleRejectMember(member) {
      const isConfirmed = await rejectMemberPopup(member);

      if (isConfirmed) {
        this.deleteMember(member);
      }
    },

    async getMembers(size, page) {
      this.isLoading = true;
      const params = {
        size: size ? size : 10,
        page: page ? page : 1,
      }

      memberApi.getTemporaryMember(params).then(res => {
        if (res.status === 200) {
          this.members = res ? res.data.response : this.members;
        }
      }).finally(() => this.isLoading = false);
    },

    async updateMemberType(member, memberType) {
      const data = {
        member_type: memberType
      }

      await memberApi.updateMemberType(member, data).then(res => {
        if (res.status === 200) {
          this.getMembers(this.members.page_info.size, this.members.page_info.page);
        }
      });
    },

    async deleteMember(member) {
      await memberApi.realDeleteMember(member).then(res => {
        if (res.status === 204) {
          this.getMembers(this.members.page_info.size, this.members.page_info.page);
        }
      });
    },

    updatePagination(pagination) {
      this.members.page_info.size = pagination.size;
      this.members.page_info.page = pagination.page;

      this.getMembers(pagination.size, pagination.page);
    }
  }
};
</script>

<style lang="css" scoped></style>
